var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wm-75 mx-auto mt-2"},[(_vm.isLoaded)?_c('TabNavigation',{class:"mx-auto wm-100 tab-navigation",attrs:{"tabs":_vm.tabs,"tabQueryName":"tab-project"},on:{"updateProject":_vm.getProject}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }